import { TbBasket, TbBasketCheck } from "react-icons/tb";
import { trackAddToBasket } from "../../functions/metaPixel";

const BasketButton = ({
  onClick,
  disabled,
  basketAnim,
  size,
  stockStatus,
  product,
  displayPrice,
  displaySymbol,
  currencyCode,
}) => {
  const inStock =
    !stockStatus || stockStatus.toLowerCase().includes("in stock");

  const canAdd = !disabled && !!size && inStock;

  const productId = String(product?.id || product?.productId || "");
  const numericPrice = Number(displayPrice) || 0;

  const buttonText = !size
    ? "Select a Size"
    : !inStock
      ? "Out of Stock"
      : displayPrice
        ? `Get Yours Now - ${displaySymbol || ""}${displayPrice}`
        : "Add to Basket";

  const handleClick = (e) => {
    if (!canAdd || !productId) return;

    if (onClick) onClick(e);

    trackAddToBasket({
      content_ids: [productId],
      content_type: "product",
      content_name: product?.title || "",
      content_category: product?.category || "",
      contents: [
        {
          id: productId,
          quantity: 1,
          item_price: numericPrice,
          size: size || "",
        },
      ],
      value: numericPrice,
      currency: currencyCode || "GBP",
    });
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleClick}
        className="si_button"
        disabled={!canAdd}
        aria-disabled={!canAdd}
        style={{
          opacity: canAdd ? 1 : 0.5,
          cursor: canAdd ? "pointer" : "not-allowed",
        }}
      >
        <div
          className={`si_button_content${basketAnim ? " basket-anim" : ""}`}
          aria-live="polite"
        >
          {basketAnim ? (
            <TbBasketCheck className="basket-icon-anim" />
          ) : (
            <TbBasket className="basket-icon-anim" />
          )}
          <span className="si_button_text">{buttonText}</span>
        </div>
      </button>
    </div>
  );
};

export default BasketButton;
